import { Box, Button, CircularProgress, Paper, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch } from "react-redux";
import { imageStudioActions } from "../../store/imageStudio";
import { httpsCallable } from "firebase/functions";
import { functions } from "firebaseApp";

export default function ImagePreview({
  image,
  previewSize = 100,
  setPreview,
}) {
  const dispatch = useDispatch();

  const [hover, setHover] = useState(false);

  useEffect(() => {
    uploadImage();
  }, []);

  const uploadImage = async () => {
    if (!image) return;
    if (!image.base64) return;
    if (image.imageUrl) return;
    try {
      dispatch(
        imageStudioActions.updateImage({
          index: image.index,
          data: {
            uploading: true,
            error: "",
          },
        })
      );
      const response = await httpsCallable(
        functions,
        "uploadBase64Images"
      )({
        images: [image.base64],
      });
      // const uploadBase64Image = httpsCallable(functions, "uploadBase64Image");
      // const response = await uploadBase64Image({
      //   fileName: image.name,
      //   base64Image: image.base64,
      //   bucketName,
      // });
      const responseData = response.data;

      if (responseData.error) {
        dispatch(
          imageStudioActions.updateImage({
            index: image.index,
            data: {
              uploading: false,
              error: responseData.error,
            },
          })
        );
      } else {
        const [imageData] = response.data.images;
        dispatch(
          imageStudioActions.updateImage({
            index: image.index,
            data: {
              uploading: false,
              ...imageData,
            },
          })
        );
      }
    } catch (error) {
      console.log(error);
      dispatch(
        imageStudioActions.updateImage({
          index: image.index,
          data: {
            uploading: false,
            error: "An error occured",
          },
        })
      );
    }
  };

  if (!image || (!image.base64 && !image.imageUrl)) {
    console.log("no image")
    return null;
  }

  return (
    <Paper>
      <Stack
        alignItems="center"
        justifyContent="center"
        width={`${previewSize}px`}
        height={`${previewSize}px`}
        position="relative"
        sx={{
          cursor: "pointer",
          opacity: image.uploading ? 0.5 : 1,
        }}
        onClick={() =>
          setPreview({
            ...image,
            uploadImage,
          })
        }
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Box
          component="img"
          src={image.base64 || image.imageUrl}
          alt={`Image`}
          sx={{
            maxWidth: "100px",
            maxHeight: "100px",
            objectFit: "contain",
          }}
        />
        <Stack
          alignItems="center"
          justifyContent="center"
          position="absolute"
          width="100%"
          height="100%"
          left="0"
          top="0"
        >
          {image.uploading && <CircularProgress size={24} color="secondary" />}
          {image.error && (
            <Button
              color="error"
              onClick={uploadImage}
              startIcon={<ReplayIcon />}
            >
              Retry
            </Button>
          )}
          {hover && !image.error && <SearchIcon color="secondary" />}
        </Stack>
      </Stack>
    </Paper>
  );
}
